import ConfigurableBackground from './_configurable-background.js'
import ConfigurableMargin from './_configurable-margin.js'
import ConfigurablePadding from './_configurable-padding.js'
import BorderStyle from './_border-style.js'
import ConfigurableText from './_configurable-text.js'

export default {
  name: 'TextView',
  values: {
    content: {
      style: {
        padding: 0,
        margin: 0,
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
          {
            configSet: ConfigurableMargin,
          },
          {
            configSet: ConfigurablePadding,
          },
        ],
      },
      borderStyle: {
        configSet: BorderStyle,
        configValues: {},
      },
    },
    header: {
      style: {
        padding: '5px',
        margin: 0,
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
          {
            configSet: ConfigurableMargin,
          },
          {
            configSet: ConfigurablePadding,
          },
        ],
      },
      borderStyle: {
        configSet: BorderStyle,
        configValues: {
          borderWidth: '0 0 1px 0',
          borderColor: 'rgba(83, 83, 83, 0.5)',
        },
      },
      textStyle: {
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
    },
    textArea: {
      style: {
        padding: '20px 0 20px 0',
        margin: 0,
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
          {
            configSet: ConfigurableMargin,
          },
          {
            configSet: ConfigurablePadding,
          },
        ],
      },
      borderStyle: {
        configSet: BorderStyle,
        configValues: {
          borderWidth: '0 0 1px 0',
          borderColor: 'rgba(83, 83, 83, 0.5)',
        },
      },
      textStyle: {
        style: undefined,
        $mixin: [
          {
            configSet: ConfigurableText,
          },
        ],
      },
    },
  },
  meta: {
    extendable: false,
  },
}
